import { Outlet, createFileRoute } from "@tanstack/react-router";
import queryClient from "api/queryClient.ts";
import { getScenarioQueryOptions } from "api/TenantSlug/ConnectionCreator/queryOptions.ts";
import { QueryState } from "components/UI/QueryState/QueryState.tsx";

export const Route = createFileRoute(
    "/_authenticated/$tenantSlug/_layout/tool/_layout/validation/_layout/$scenarioId/_layout"
)({
    loader: async ({ params: { scenarioId } }) => {
        let breadcrumb = scenarioId;

        try {
            const { scenario } = await queryClient.ensureQueryData(getScenarioQueryOptions(scenarioId));

            breadcrumb = scenario.title;
        } catch (e) {
            console.error(e);
        }

        return {
            breadcrumb,
        };
    },
    pendingComponent: () => <QueryState isLoading={true} isError={false} />,
    errorComponent: () => <QueryState isLoading={false} isError={true} errorKey="errors.loading_scenario" />,
    component: () => <Outlet />,
});
